import React from 'react';
import { Link } from 'react-router-dom';

interface CTASectionProps {
  showCtaSection?: boolean;
  title: string;
  subtitle: string;
  primaryBtnText: string;
  primaryBtnUrl: string;
  secondaryBtnText: string;
  secondaryBtnUrl: string;
  stat1Number: string;
  stat1Label: string;
  stat2Number: string;
  stat2Label: string;
  stat3Number: string;
  stat3Label: string;
}

const CTASection: React.FC<CTASectionProps> = ({
  showCtaSection = true,
  title,
  subtitle,
  primaryBtnText,
  primaryBtnUrl,
  secondaryBtnText,
  secondaryBtnUrl,
  stat1Number,
  stat1Label,
  stat2Number,
  stat2Label,
  stat3Number,
  stat3Label
}) => {
  if (!showCtaSection) {
    return null;
  }

  return (
    <section className="landing-cta">
      <div className="landing-container">
        <h2>{title}</h2>
        <p>{subtitle}</p>

        <div className="landing-cta-buttons">
          <Link
            to={primaryBtnUrl}
            className="landing-cta-btn-primary"
            data-discover="true"
          >
            {primaryBtnText}
          </Link>
          <Link
            to={secondaryBtnUrl}
            className="landing-cta-btn-secondary"
            data-discover="true"
          >
            {secondaryBtnText}
          </Link>
        </div>

        <div className="landing-cta-stats">
          <div className="landing-cta-stat">
            <div className="landing-cta-stat-number">{stat1Number}</div>
            <div className="landing-cta-stat-label">{stat1Label}</div>
          </div>
          <div className="landing-cta-stat">
            <div className="landing-cta-stat-number">{stat2Number}</div>
            <div className="landing-cta-stat-label">{stat2Label}</div>
          </div>
          <div className="landing-cta-stat">
            <div className="landing-cta-stat-number">{stat3Number}</div>
            <div className="landing-cta-stat-label">{stat3Label}</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;